// HomePage.jsx
import './HomePage.css';
import gpuvs from "../assets/gpuvs.png";
import nvidia5090 from "../assets/nvidia5090.jpg";
import pixelrog from "../assets/pixelrog.gif";
import logoscreen from "../assets/logoscreen.png";
import heroimage from "../assets/hero.png";
import { Helmet } from "react-helmet"; // SEO
import { Button } from '../components/button'; // Adjust the path if necessary

const HomePage = () => {

  return (
    <div className="homepage-container">

      {/* SEO Metadata */}
      <Helmet>
        <title>PCBuildGuru – Compare & Build Your Perfect PC</title>
        <meta
          name="description"
          content="PCBuildGuru helps you compare PC components, get expert build recommendations, and learn how to assemble your dream PC."
        />
        <meta
          name="keywords"
          content="PC build guide, gaming PC, compare components, PC parts, custom PC"
        />
        <meta property="og:title" content="PCBuildGuru – Compare & Build Your Perfect PC" />
        <meta property="og:description" content="Build your dream PC with expert comparisons and personalized recommendations." />
        <meta property="og:image" content={heroimage} />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Hero Section */}
      {/* Hero Section */}
      <section className="video-banner full-screen">
        <img
          src={heroimage}
          alt="Custom PC build showcase with components and RGB lighting"
          className="responsive-bg"
        />
        <div className="hero-text">
          <h1>Build Your Dream PC</h1>
          <p>
            Compare GPUs, CPUs, motherboards, and more.  
            Get expert recommendations tailored to your needs.
          </p>
          <Button href="/questionnaire" className="hero-button btn-primary">
            Build With AI
          </Button>
        </div>
      </section>

      {/* Existing sections */}
      <div className="two-images-section">

        <section className="full-screen first-section">
          <img
            src={gpuvs}
            alt="GPU comparison chart of latest NVIDIA and AMD graphics cards"
            className="responsive-bg"
          />
          <Button className="section-btn" href="/compare">Compare GPUs</Button>
        </section>

        <section className="full-screen second-section">
          <img
            src={nvidia5090}
            alt="NVIDIA RTX 5090 performance comparison with previous generations"
            className="responsive-bg"
          />
          <div className="text-container">
            <h1>Find Out Who's Leading</h1>
            <p>
              Discover the latest in GPU, CPU, and motherboard technology.<br />
              Our charts and comparisons help you find the best components for your build.
            </p>
            <Button className="section-btn">See Charts</Button>
          </div>
        </section>

        <section className="full-screen first-section">
          <img
            src={logoscreen}
            alt="PCBuildGuru logo screen"
            className="responsive-bg"
          />
        </section>

        <section className="full-screen pixelrog-section">
          <img
            src={pixelrog}
            alt="Animated RGB PC build"
            className="responsive-bg"
          />
          <div className="pixel-text">RGB? We got you!</div>
        </section>

      </div>
    </div>
  );
};

export default HomePage;
